// extracted by mini-css-extract-plugin
export default {"rootLoginPage":"LayoutLogin_rootLoginPage__HD1GF","formLogin":"LayoutLogin_formLogin__9OmMN"};